/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReports1Route } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReports1Route.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getReportsWithKbResources } from './common/getReportsWithKbResources.tsx';
import HomePage, { LazyServicedeskReportsHomePage } from './ui/home-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskReports1RouteEntry: Route = createEntry(servicedeskReports1Route, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: HomePage,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getReportsWithKbResources(),
		getConsolidationStateResource(),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsHomePage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
